module.exports = __webpack_public_path__ + "img/materiais-1.64373266.svg";